import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class PreviewGoalError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('PreviewGoalError', ...args);
    }
}
export default PreviewGoalError;
